<div [class.box-error-alert]="type === 'box'" class="w-100-p" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
    <mat-icon color="warn">error</mat-icon>
    <div class="w-100-p">
        <div class="text-bold">
            <ng-content select="[errorTitle]"></ng-content>
        </div>
        <ng-content select="[errorMessage]"></ng-content>
    </div>
</div>
